import type { WebPushUiState } from './web-push-state'

export type HomeScreenNotificationSetupState
  = | 'checking'
    | 'active'
    | 'needs-setup'

export function homeScreenNotificationSetupState(
  state: WebPushUiState,
  statePending: boolean,
): HomeScreenNotificationSetupState {
  if (statePending)
    return 'checking'
  return state === 'active' ? 'active' : 'needs-setup'
}
